<template lang="pug">
div(
    class="text-paragraph"
    part="text-paragraph"
    :class="classes"
)
    slot
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    small: Boolean,
    medium: Boolean,
    center: Boolean,
    right: Boolean,
})

const classes = computed(() => {
    const c = []
    if (props.small) c.push('small')
    if (props.medium) c.push('medium')
    if (props.center) c.push('text-center')
    if (props.right) c.push('text-right')
    return c.join(' ')
})
</script>

<style lang="sass" scoped>
@import './TextParagraph.sass'
</style>
